import getThumbnailHeight from '../../../helpers/getThumbnailHeight';
import { useEffect, useState, RefObject } from 'react';

import { Player, VideoSizes } from '../../../types';

type ThumbnailWidthProps = {
  currentVideo: RefObject<HTMLDivElement>;
  sizes: VideoSizes;
  player: Player | null;
};

const useThumbnailWidth = ({ sizes, player, currentVideo }: ThumbnailWidthProps) => {
  const [thumbnailWidth, setThumbnailWidth] = useState<number>();

  useEffect(() => {
    if (!currentVideo.current || !player) return;

    const { width, height } = sizes;
    const ratio = width / height;
    const isVertical = ratio <= 1;

    setThumbnailWidth(Math.floor(getThumbnailHeight(isVertical) * ratio));
  }, [player]);

  return thumbnailWidth;
};

export default useThumbnailWidth;
